import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <path
                    fill="currentcolor"
                    d="M4.699.121c2.308 0 4.178 1.796 4.178 4.01 0 .846-.272 1.63-.738 2.278l2.376 2.281c.281.27.29.718.02 1l-.02.02a.767.767 0 01-1.063 0L7.078 7.43a4.281 4.281 0 01-2.38.712C2.392 8.142.52 6.347.52 4.132S2.39.122 4.699.122zm0 1.433c-1.484 0-2.687 1.154-2.687 2.578S3.215 6.71 4.7 6.71c1.483 0 2.686-1.154 2.686-2.578S6.182 1.554 4.699 1.554z"
                ></path>
            </g>
        </svg>
    );
};

export default React.memo(Search);
